// ─── Seção de Busca e Filtros (+ Seção dos Posts) ────────────────────────────
function initConteudosFiltros() {
  const buscaSection = document.querySelector("[data-conteudos-busca]");
  const content = document.querySelector("[data-conteudos-posts-content]");

  if (!buscaSection || !content) {
    return;
  }

  const ajaxUrl = buscaSection.dataset.ajaxUrl;
  const nonce = buscaSection.dataset.nonce;
  const baseUrl = buscaSection.dataset.baseUrl;

  const tabs = Array.from(
    buscaSection.querySelectorAll(".conteudos-busca__tab"),
  );
  const searchWrap = buscaSection.querySelector("[data-conteudos-search]");
  const searchToggle = buscaSection.querySelector(
    "[data-conteudos-search-toggle]",
  );
  const searchInput = buscaSection.querySelector(
    "[data-conteudos-search-input]",
  );
  const filterWrap = buscaSection.querySelector("[data-conteudos-filter]");
  const filterToggle = buscaSection.querySelector(
    "[data-conteudos-filter-toggle]",
  );
  const filterDropdown = buscaSection.querySelector(
    "[data-conteudos-filter-dropdown]",
  );
  const filterCheckboxes = Array.from(
    buscaSection.querySelectorAll("[data-conteudos-filter-checkbox]"),
  );

  let currentAba =
    tabs.find((tab) => tab.classList.contains("is-active"))?.dataset.aba ||
    "todos";
  let currentTipos = filterCheckboxes
    .filter((checkbox) => checkbox.checked)
    .map((checkbox) => checkbox.value);
  let currentBusca = searchInput ? searchInput.value.trim() : "";

  const buildUrl = (aba, tipos, busca, pagina) => {
    const url = new URL(baseUrl, window.location.origin);

    if (aba && aba !== "todos") {
      url.searchParams.set("aba", aba);
    }

    if (tipos.length) {
      url.searchParams.set("tipos", tipos.join(","));
    }

    if (busca) {
      url.searchParams.set("busca", busca);
    }

    if (pagina && pagina !== "1") {
      url.searchParams.set("pagina", pagina);
    }

    return `${url.pathname}${url.search}`;
  };

  const setActiveTab = (aba) => {
    tabs.forEach((tab) =>
      tab.classList.toggle("is-active", tab.dataset.aba === aba),
    );
  };

  const load = (aba, tipos, busca, pagina, pushUrl, scrollAfter) => {
    currentAba = aba;
    currentTipos = tipos;
    currentBusca = busca;

    const body = new URLSearchParams({
      action: "utrax_filter_conteudos",
      nonce,
      aba,
      tipos: tipos.join(","),
      busca,
      pagina,
      base_url: baseUrl,
    });

    content.classList.add("is-loading");

    fetch(ajaxUrl, { method: "POST", body })
      .then((response) => response.json())
      .then((json) => {
        if (!json.success) {
          return;
        }

        content.innerHTML = json.data.html;
        setActiveTab(aba);

        if (pushUrl) {
          window.history.pushState({ aba, tipos, busca, pagina }, "", pushUrl);
        }

        if (scrollAfter) {
          buscaSection.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      })
      .finally(() => {
        content.classList.remove("is-loading");
      });
  };

  // ── Tabs ─────────────────────────────────────────────────────────────────────
  tabs.forEach((tab) => {
    tab.addEventListener("click", (event) => {
      event.preventDefault();
      const aba = tab.dataset.aba;
      const pushUrl = buildUrl(aba, currentTipos, currentBusca, "1");
      load(aba, currentTipos, currentBusca, "1", pushUrl);
    });
  });

  content.addEventListener("click", (event) => {
    const link = event.target.closest(
      ".conteudos-posts__pagination a.page-numbers",
    );

    if (!link) {
      return;
    }

    event.preventDefault();
    const url = new URL(link.href, window.location.origin);
    const pagina = url.searchParams.get("pagina") || "1";
    const pushUrl = `${url.pathname}${url.search}`;
    load(currentAba, currentTipos, currentBusca, pagina, pushUrl, true);
  });

  // ── Busca: abre/fecha (animação via CSS) e filtra com debounce ────────────────
  if (searchToggle && searchInput && searchWrap) {
    searchToggle.addEventListener("click", () => {
      const isOpen = searchWrap.classList.toggle("is-open");
      searchToggle.setAttribute("aria-expanded", String(isOpen));

      if (isOpen) {
        searchInput.focus();
        return;
      }

      if (currentBusca) {
        searchInput.value = "";
        const pushUrl = buildUrl(currentAba, currentTipos, "", "1");
        load(currentAba, currentTipos, "", "1", pushUrl);
      }
    });

    let debounceId = null;

    searchInput.addEventListener("input", () => {
      const busca = searchInput.value.trim();

      clearTimeout(debounceId);
      debounceId = setTimeout(() => {
        const pushUrl = buildUrl(currentAba, currentTipos, busca, "1");
        load(currentAba, currentTipos, busca, "1", pushUrl);
      }, 300);
    });

    document.addEventListener("click", (event) => {
      if (searchWrap.contains(event.target)) {
        return;
      }

      if (searchInput.value.trim() === "") {
        searchWrap.classList.remove("is-open");
        searchToggle.setAttribute("aria-expanded", "false");
      }
    });
  }

  // ── Dropdown "Filtrar por" (multi-select) ──────────────────────────────────────
  if (filterToggle && filterDropdown && filterWrap) {
    filterToggle.addEventListener("click", (event) => {
      event.stopPropagation();
      const isOpen = filterWrap.classList.toggle("is-open");
      filterToggle.setAttribute("aria-expanded", String(isOpen));
      filterDropdown.hidden = !isOpen;
    });

    document.addEventListener("click", (event) => {
      if (!filterWrap.contains(event.target)) {
        filterWrap.classList.remove("is-open");
        filterToggle.setAttribute("aria-expanded", "false");
        filterDropdown.hidden = true;
      }
    });

    filterCheckboxes.forEach((checkbox) => {
      checkbox.addEventListener("change", () => {
        const tipos = filterCheckboxes
          .filter((c) => c.checked)
          .map((c) => c.value);
        const pushUrl = buildUrl(currentAba, tipos, currentBusca, "1");
        load(currentAba, tipos, currentBusca, "1", pushUrl);
      });
    });
  }

  // ── Voltar/avançar no navegador ─────────────────────────────────────────────────
  window.addEventListener("popstate", () => {
    const url = new URL(window.location.href);
    const aba = url.searchParams.get("aba") || "todos";
    const tipos = (url.searchParams.get("tipos") || "")
      .split(",")
      .filter(Boolean);
    const busca = url.searchParams.get("busca") || "";
    const pagina = url.searchParams.get("pagina") || "1";

    load(aba, tipos, busca, pagina, null);

    if (searchInput) {
      searchInput.value = busca;
      searchWrap?.classList.toggle("is-open", busca !== "");
    }

    filterCheckboxes.forEach((checkbox) => {
      checkbox.checked = tipos.includes(checkbox.value);
    });
  });
}

document.addEventListener("DOMContentLoaded", () => {
  initConteudosFiltros();
});
